/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * email_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Progress/terminal state of a backfill job for [`RefreshEmailEvent::Backfill`].
 */
export type BackfillStatus =
  (typeof BackfillStatus)[keyof typeof BackfillStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackfillStatus = {
  progress: 'progress',
  complete: 'complete',
  failed: 'failed',
} as const;
